import { render, staticRenderFns } from "./AccountButton.vue?vue&type=template&id=9080e7ec&scoped=true"
import script from "./AccountButton.vue?vue&type=script&lang=js"
export * from "./AccountButton.vue?vue&type=script&lang=js"
import style0 from "./AccountButton.vue?vue&type=style&index=0&id=9080e7ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9080e7ec",
  null
  
)

export default component.exports